import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { motion } from 'framer-motion';

import { Colors } from '../../themes/colors';
import { removeFavoriteProfessional } from '../../actions';
import ConfirmPopup from '../shared/ConfirmPopup';
import StarIcon from '../../images/icons/Star';

const renderProfession = (code) => {
  if (code === 'RDH') {
    return 'Dental Hygienist';
  }
  if (code === 'DA') {
    return 'Dental Assistant';
  }
  if (code === 'DN') {
    return 'Associate Dentist';
  }
};

const FavoriteCard = ({
  name, profession, level, imageSrc, id, isAvailable
}) => {
  const dispatch = useDispatch();

  const [showRemoveModal, setShowRemoveModal] = useState(false);

  const handleShowRemoveModal = () => {
    setShowRemoveModal(!showRemoveModal);
  };

  const unavailableColorText = isAvailable ? Colors.neutral_500 : Colors.neutral_300;
  const unavailableColor = isAvailable ? Colors.favorites_400 : Colors.neutral_300;

  return (
    <motion.div
      key={id}
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0 }}
      transition={{
        duration: 0.5,
        exit: { duration: 0.2 },
        layout: { duration: 0.3 },
      }}
      layout
      style={{
        position: 'relative',
        padding: '35px 30px',
        display: 'flex',
        backgroundColor: Colors.neutral_50,
        borderRadius: '16px',
        boxShadow: isAvailable ? '0px 2px 4px 0px rgba(111, 131, 141, 0.33)' : '',
      }}
    >
      <img
        src={imageSrc}
        alt="Profile"
        style={{
          filter: isAvailable ? 'none' : 'grayscale(100%)',
          opacity: isAvailable ? 1 : 0.5,
          width: '105px',
          height: '105px',
          borderRadius: '50%',
          border: `3px solid ${unavailableColor}`,
          boxShadow: '0px 3px 10px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px 0px rgba(0, 0, 0, 0.15)',
        }}
      />
      <div style={{ marginLeft: '24px' }}>
        <h3 className="global_font f-20" style={{ color: isAvailable ? Colors.neutral_600 : Colors.neutral_300, lineHeight: 0, whiteSpace: 'nowrap' }}>{name}</h3>
        {isAvailable && (
          <p className="global_font f-16" style={{ color: unavailableColorText, lineHeight: 0.5 }}>{renderProfession(profession)}</p>
        )}
        <p className="global_font f-16" style={{ color: unavailableColorText, lineHeight: isAvailable ? 0.25 : 0.5, fontWeight: 'bold' }}>
          Activity Level:
          {' '}
          <span style={{ fontWeight: 'normal', textTransform: 'capitalize' }}>{level}</span>
        </p>
        {!isAvailable && (
          <p className="global_font f-16" style={{ color: unavailableColorText, lineHeight: 0.25 }}>Currently Unavailable</p>
        )}
      </div>
      <div
        style={{
          position: 'absolute',
          top: '-10px',
          right: '-10px',
          backgroundColor: 'transparent',
          cursor: 'pointer',
        }}
        onClick={handleShowRemoveModal}
      >
        <StarIcon color={Colors.favorites_400} />
      </div>

      {showRemoveModal && (
        <ConfirmPopup
          title="Removal Confirmation"
          description={(
            <>
              Please confirm that you would like to remove
              {' '}
              <span style={{ fontWeight: 'bold' }}>{name}</span>
              {' '}
              from your Favorites List.
            </>
          )}
          leftButtonText="Cancel"
          leftButtonAction={() => handleShowRemoveModal()}
          rightButtonText="Remove"
          rightButtonAction={() => {
            dispatch(removeFavoriteProfessional({ userId: id }));
            handleShowRemoveModal();
          }}
        />
      )}
    </motion.div>
  );
};

export default FavoriteCard;
